import { types as t, } from 'mobx-state-tree';
//import DataTypePreValue from './DataTypePreValue'

const DataType = t.model("DataType", {
	Id: t.identifier,
	Name: t.string,
    DefinitionName: t.string,
	//PreValues: t.array(DataTypePreValue)
    // todo: Prevalues
}).views(self => ({

})).actions(self => ({

}));

export default DataType;